export enum ColorStatus {
  Green = 'green',
  Blue = 'blue',
  Transparent = 'transparent'
}